import {Vue, Component, Watch} from 'vue-property-decorator';
import { required } from 'vuelidate/lib/validators';

import * as service from "@/methods/service";


const validations = {
	fullAddress: { required },
}

@Component({
	validations
})

export default class CheckAddress extends Vue {

	address = '';
	fullAddress = '';
	autocomplete = '';
	city = '';
	country = '';
	postcode = '';
	state = '';
	inputValue = '';

	error = ''


	areaUnavailable = false;

	mounted() {
		if(this.$store.getters.postcode){
			this.postcode = this.$store.getters.postcode
			this.state = this.$store.getters.stateCountry
			this.city = this.$store.getters.city
			this.address = 	this.$store.getters.address
			this.country = 	this.$store.getters.country
			this.fullAddress = `${this.$store.getters.address} ${this.$store.getters.city} ${this.$store.getters.stateCountry.toUpperCase()} ${this.$store.getters.country[0].toUpperCase() + this.$store.getters.country.slice(1)}`
		}

		let address1Field = document.getElementById('autocomplete');
		//@ts-ignore
		this.autocomplete = new google.maps.places.Autocomplete(address1Field, {
			componentRestrictions: { country: ["ca", "us"] },
			fields: ["address_components", 'formatted_address'],
			types: ["address"],
		});
		//@ts-ignore
		address1Field.addEventListener('paste', (e)=> {

			//@ts-ignore
			const sessionToken = new google.maps.places.AutocompleteSessionToken();
			//@ts-ignore
			const servicePlace = new google.maps.places.PlacesService(document.getElementById('autocomplete'));
			//@ts-ignore
			const service = new google.maps.places.AutocompleteService();
			//@ts-ignore
			const textInput = e.clipboardData.getData('Text')
			if(textInput){

				const displaySuggestions = (predictions:any, status:any) => {
					//@ts-ignore
					if (status != google.maps.places.PlacesServiceStatus.OK || !predictions) {
						return;
					}

					if(predictions.length === 1){

						var request = {
							placeId: predictions[0].place_id,
							fields: ["address_components", 'formatted_address'],
							sessionToken: sessionToken
						};


						servicePlace.getDetails(request, (place:any, status:any) => {
							//@ts-ignore
							if (status == google.maps.places.PlacesServiceStatus.OK) {
								this.addressParse(place)
							}
						});
					}
					else if(predictions.length > 1){
						this.address = '';
						this.postcode = '';
						this.city = '';
						this.country = '';
						this.state = '';
					}
				};

				service.getPlacePredictions({ input: textInput, sessionToken: sessionToken, componentRestrictions: { country: ["ca", "us"] },
					fields: ["address_components"],
					types: ["address"],  }, displaySuggestions);
			}
		});

		//@ts-ignore
		this.autocomplete.addListener("place_changed", this.fillInAddress);
	}

	async checkNow() {
		this.$store.commit('setOverlay', true)
		try {
			await service.updatePrimaryFranchiseByPostalCode(this.postcode)
			this.$store.commit('updateAddress', this.address);
			this.$store.commit('updatePostcode', this.postcode);
			this.$store.commit('updateCity', this.city);
			this.$store.commit('updateStateCountry', this.state);
			this.$store.commit('updateCountry', this.country);
			this.$store.commit('setFirstStepComplited');
			this.$store.commit('setOverlay', false)
			this.$router.push({ name: 'secondStep', params: {} })
		} catch (e) {
			this.$store.commit('setOverlay', false)
			if(e.message === 'Zip is not in service.'){
				e.message = 'Postal Code is not in service.'
			}
			this.error = e.message;
		}
	}

	@Watch('fullAddress')
	watchFullName() {
		if(this.fullAddress === ''){
			this.address = '';
			this.postcode = '';
			this.city = '';
			this.country = '';
			this.state = '';
		}
	}

	addressParse(place:any){
		this.error = ''
		//@ts-ignore
		for (const component of place.address_components as google.maps.GeocoderAddressComponent[]) {
			const componentType = component.types[0];

			switch (componentType) {
				case "street_number": {
					this.address = component.long_name;
					break;
				}

				case "route": {
					this.address = `${this.address} ${component.short_name} `;
					break;
				}

				case "postal_code": {
					this.postcode = `${component.long_name}`;
					this.postcode = this.postcode.replace(/\s+/g, '');
					break;
				}

				// case "postal_code_suffix": {
				// 	this.postcode = `${this.postcode}-${component.long_name}`;
				// 	this.$store.commit('updatePostcode', this.postcode);
				// 	break;
				// }
				case "locality":
					this.city = component.long_name;
					break;

				case "administrative_area_level_1": {
					this.state = component.short_name;
					this.state = this.state.toLowerCase();
					break;
				}

				case "country": {
					this.country = component.long_name;
					this.country = this.country.toLowerCase();
					break;
				}
			}
		}
		this.fullAddress = place.formatted_address
	}

	fillInAddress() {
		//@ts-ignore
		const place = this.autocomplete.getPlace();
		this.address = '';
		this.fullAddress = '';
		this.postcode = '';
		this.city = '';
		this.country = '';
		this.state = '';
		this.addressParse(place)
	}
}
